var map = {
	"./Calender.png": 7691,
	"./Instructions.png": 2630,
	"./PT Treatement Dashboard.png": 8088,
	"./Patient Progress.png": 8965,
	"./Prescription.png": 6541,
	"./Rehab Info.png": 3649,
	"./Statistics.png": 948,
	"./Treatement.png": 7852
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6512;